import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const PricesTab = ({ analysis }) => {
    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Confronto Prezzi Prodotti</h2>
            {analysis.priceData.length > 0 ? (
                <>
                    <ResponsiveContainer width="100%" height={400}>
                        <BarChart data={analysis.priceData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" angle={-45} textAnchor="end" height={120} />
                            <YAxis />
                            <Tooltip
                                content={({ active, payload }) => {
                                    if (active && payload && payload.length) {
                                        return (
                                            <div className="bg-white p-3 border rounded shadow-lg">
                                                <p className="font-semibold text-xs">{payload[0].payload.name}</p>
                                                <p className="text-green-600 font-bold">{payload[0].payload.currency} {payload[0].value}</p>
                                                <p className="text-sm text-gray-600">{payload[0].payload.seller}</p>
                                            </div>
                                        );
                                    }
                                    return null;
                                }}
                            />
                            <Legend />
                            <Bar dataKey="price" fill="#10b981" name="Prezzo" />
                        </BarChart>
                    </ResponsiveContainer>

                    <div className="mt-4 p-4 bg-yellow-50 rounded-lg">
                        <p className="text-sm">
                            <strong>Range prezzi:</strong> da {analysis.priceData[0].currency} {Math.min(...analysis.priceData.map(p => p.price))} a {analysis.priceData[0].currency} {Math.max(...analysis.priceData.map(p => p.price))}
                        </p>
                    </div>
                </>
            ) : (
                <p className="text-gray-500 text-center py-8">Nessun dato sui prezzi disponibile</p>
            )}
        </div>
    );
};

export default PricesTab;
